




import * as breakpoint from '../interfaces/breakpoint';


// Get height of elements based on selector
export function getElemHeight (selector: string) : number {
    const headerElements : NodeListOf<HTMLElement> =
        document.querySelectorAll(selector);

    return Array.from(headerElements)
        .reduce( (height, elem) =>
            height + elem.getBoundingClientRect().height
        , 0);
}


export const mediaBreakpoint = (dir : breakpoint.Dir) : Function => (size : breakpoint.Size) : Boolean => {
    if ( dir === 'up' ) {
        return window.innerWidth > size;
    }
    return window.innerWidth <= size;
};
